<div class="white-block shadow-block mb-4">
  <div class="row mb-n3">
    <div class="col-12 col-md-6 col-lg-4 mb-3">
      <h5><strong>Directions</strong></h5>
      @if (item.directions) {
        <div [innerHTML]="item.directions"></div>
      } @else {
        {{ item.venueAddress || item.venueName || '' }}
      }
      @if (item.mapUrl || item.venueAddress || item.venueName) {
        <div>
          <a
            class="view-on-map"
            [href]="item.mapUrl || '#'"
            [attr.target]="item.mapUrl ? '_blank' : null"
            (click)="!item.mapUrl && $event.preventDefault()"
          >
            <strong><span class="icon ib-map-marker"></span> View on Map</strong>
          </a>
        </div>
      }
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-3">
      <h5><strong>Voucher Exchange</strong></h5>
      @if (item.voucherExchange) {
        <div [innerHTML]="item.voucherExchange"></div>
      }
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-3">
      <h5><strong>Cancellation policy</strong></h5>
      @if (item.nonRefundable) {
        <div>Non-refundable</div>
      } @else if (item.cancellationHours) {
        <div>Can be cancelled {{ item.cancellationHours }} hours prior event date</div>
      }
      @if (item.cancellationPolicy) {
        <div [innerHTML]="item.cancellationPolicy"></div>
      }
    </div>
  </div>
</div>
